// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FOOTER_HELP_LINK = "Zeptej se n\u00e1s";
